const INITIAL_STATE = {
  motivosCategoriasSelectOption: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'MOTIVOS_CATEGORIAS_SELECT_OPTION':
      return { ...state, motivosCategoriasSelectOption: action.payload }

    default:
      return state
  }
}